export const COMPANY = {
  name: "Y&Y Cleaning Multiservices LLC",
  shortName: "Y&Y Cleaning",
  phone: "813-401-3197",
  phoneTel: "+18134013197",
  email: "yoisbelcardenas14@gmail.com",
  zip: "33615",
  city: "Tampa, FL",
  serviceArea: "Tampa Bay, Florida",
  whatsapp: "https://wa.me/18134013197",
  smsLink:
    "sms:+18134013197?body=Hi%2C%20I%E2%80%99m%20interested%20in%20your%20solar%20panel%20services.%20I%E2%80%99d%20like%20a%20free%20estimate.%20Thank%20you.",
  googleReviewsUrl:
    "https://www.google.com/maps/place/Y%26Y+Cleaning+Multiservices+LLC/@27.6735797,-86.4459557,789773m/data=!3m1!1e3!4m18!1m9!3m8!1s0xa2c0d5a2a30fb839:0x7470db587e11661d!2sY%26Y+Cleaning+Multiservices+LLC!8m2!3d27.698638!4d-83.804601!9m1!1b1!16s%2Fg%2F11yqldz49_!3m7!1s0xa2c0d5a2a30fb839:0x7470db587e11661d!8m2!3d27.698638!4d-83.804601!9m1!1b1!16s%2Fg%2F11yqldz49_?entry=ttu&g_ep=EgoyMDI2MDUwMi4wIKXMDSoASAFQAw%3D%3D",
  social: {
    facebook: "#",
    instagram: "#",
    whatsapp: "https://wa.me/18134013197",
  },
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_panel-power-pro/artifacts/k3nu0br8_Logo.png";

export const HERO_BG =
  "https://images.unsplash.com/photo-1745187946672-2c1d8cf26a2b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxzb2xhciUyMHBhbmVsJTIwaW5zdGFsbGF0aW9ufGVufDB8fHx8MTc3Nzk0NDcyN3ww&ixlib=rb-4.1.0&q=85";

// High-quality solar panel imagery for Benefits section
export const BENEFITS_IMAGE =
  "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?auto=format&fit=crop&w=1400&q=85";

// Services — two offerings with their own galleries
export const SERVICES = [
  {
    id: "cleaning",
    title: "Solar Panel Cleaning",
    shortTitle: "Cleaning",
    description:
      "Purified-water, streak-free cleaning that restores your panels to peak efficiency — safely and without residue.",
    layout: "pairs",
    images: [
      {
        url: "https://kreativa-cdn.b-cdn.net/Y%26Y%20Solar%20Panel%20Service/Cleanings/WhatsApp%20Image%202026-06-16%20at%205.47.21%20PM.jpeg",
        label: "Before",
      },
      {
        url: "https://kreativa-cdn.b-cdn.net/Y%26Y%20Solar%20Panel%20Service/Cleanings/WhatsApp%20Image%202026-06-16%20at%205.47.12%20PM.jpeg",
        label: "After",
      },
      {
        url: "https://kreativa-cdn.b-cdn.net/Y%26Y%20Solar%20Panel%20Service/Cleanings/WhatsApp%20Image%202026-06-16%20at%205.56.30%20PM.jpeg",
        label: "Before",
      },
      {
        url: "https://kreativa-cdn.b-cdn.net/Y%26Y%20Solar%20Panel%20Service/Cleanings/WhatsApp%20Image%202026-06-16%20at%205.56.37%20PM.jpeg",
        label: "After",
      },
      {
        url: "https://kreativa-cdn.b-cdn.net/Y%26Y%20Solar%20Panel%20Service/Cleanings/WhatsApp%20Image%202026-06-16%20at%205.58.28%20PM.jpeg",
        label: "Before",
      },
      {
        url: "https://kreativa-cdn.b-cdn.net/Y%26Y%20Solar%20Panel%20Service/Cleanings/WhatsApp%20Image%202026-06-16%20at%205.58.17%20PM.jpeg",
        label: "After",
      },
    ],
  },
  {
    id: "installation",
    title: "Solar Panel Installation & Removal",
    shortTitle: "Installation & Removal",
    description:
      "Full-service panel installation, safe removal for roof repairs, and professional reinstallation by certified technicians.",
    layout: "grid",
    images: [
      { url: "https://kreativa-cdn.b-cdn.net/Y%26Y%20Solar%20Panel%20Service/Installs/WhatsApp%20Image%202026-06-16%20at%206.02.25%20PM.jpeg" },
      { url: "https://kreativa-cdn.b-cdn.net/Y%26Y%20Solar%20Panel%20Service/Installs/WhatsApp%20Image%202026-06-16%20at%206.02.45%20PM.jpeg" },
      { url: "https://kreativa-cdn.b-cdn.net/Y%26Y%20Solar%20Panel%20Service/Installs/WhatsApp%20Image%202026-06-16%20at%206.02.52%20PM.jpeg" },
      { url: "https://kreativa-cdn.b-cdn.net/Y%26Y%20Solar%20Panel%20Service/Installs/WhatsApp%20Image%202026-06-16%20at%206.03.05%20PM.jpeg" },
      { url: "https://kreativa-cdn.b-cdn.net/Y%26Y%20Solar%20Panel%20Service/Installs/WhatsApp%20Image%202026-06-16%20at%206.03.21%20PM%20(1).jpeg" },
      { url: "https://kreativa-cdn.b-cdn.net/Y%26Y%20Solar%20Panel%20Service/Installs/WhatsApp%20Image%202026-06-16%20at%206.03.21%20PM.jpeg" },
    ],
  },
];

export const CERTIFICATIONS = [
  {
    name: "SolarEdge Home Battery Certification — NA Technical",
    issuer: "SolarEdge Technologies, Inc.",
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_panel-power-pro/artifacts/b93i7bko_02780a36-c5fd-487a-98d5-5941e850f39c.jpg",
  },
  {
    name: "Enphase IQ8 Commercial Microinverter Installation & Design",
    issuer: "Enphase University",
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_panel-power-pro/artifacts/ppw86zhx_d7c572b9-96d8-4ecd-b8f1-d166db614b30.jpg",
  },
  {
    name: "Installer Certificate of Completion — Franklin Home Power",
    issuer: "FranklinWH Energy Storage Inc.",
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_panel-power-pro/artifacts/yn9dwp2g_WhatsApp%20Image%202026-07-30%20at%2011.22.16%20PM.jpeg",
  },
  {
    name: "Certificate of Installer — Authorized FranklinWH Installer",
    issuer: "FranklinWH Energy Storage Inc.",
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_panel-power-pro/artifacts/c83gwk21_WhatsApp%20Image%202026-07-30%20at%2011.22.16%20PM%20%281%29.jpeg",
  },
];

export const TRUCK_IMAGES = [
  "https://customer-assets.emergentagent.com/job_panel-power-pro/artifacts/2a871nfs_WhatsApp%20Image%202026-05-11%20at%207.24.02%20PM%20%281%29.jpeg",
  "https://customer-assets.emergentagent.com/job_panel-power-pro/artifacts/g3f3dmjs_WhatsApp%20Image%202026-05-11%20at%207.24.02%20PM.jpeg",
  "https://customer-assets.emergentagent.com/job_panel-power-pro/artifacts/m6wttpkj_WhatsApp%20Image%202026-05-11%20at%207.24.00%20PM%20%282%29.jpeg",
  "https://customer-assets.emergentagent.com/job_panel-power-pro/artifacts/eee9z5xw_WhatsApp%20Image%202026-05-11%20at%207.24.00%20PM%20%281%29.jpeg",
];

export const TESTIMONIALS = [
  {
    name: "Charles James",
    rating: 5,
    date: "3/2/2026",
    text: "Very professional, and my panels look and perform amazingly! 🙂",
  },
  {
    name: "Jimmy Sosa",
    rating: 5,
    date: "5/4/2026",
    text: "The guys came over early and were done quickly. I am very happy with the work.",
  },
  {
    name: "Nancy Goodness",
    rating: 5,
    date: "4/2/2026",
    text: "Yosbel is an incredibly hard worker. He fixed my solar system, and I couldn't be happier with the work.",
  },
  {
    name: "Juan",
    rating: 5,
    date: "4/7/2026",
    text: "Great performance they did everything right and for a really good price. They are punctual and knowledgeable. I would recommend them.",
  },
  {
    name: "Eliecer Tamayo",
    rating: 5,
    date: "2/15/2026",
    text: "Excellent team. The system is working perfectly. Thank you.",
  },
  {
    name: "Hector Morales",
    rating: 5,
    date: "3/5/2026",
    text: "Very satisfied, I highly recommend him. He explains step by step what he's doing and why, he answers messages quickly, and if he has a problem, he lets you know. When he tells you a day and time, he does everything he can to make sure it's there. I'd give him 20 stars.",
  },
  {
    name: "Lismeivy Gonzales",
    rating: 5,
    date: "11/2/2026",
    text: "Excellent service and I loved how clean my house was after the job. 10 out of 10 😍😍😍😍😍",
  },
  {
    name: "Kanny Flores",
    rating: 5,
    date: "12/4/2025",
    text: "Excellent service, very disciplined, and the agents left my house looking brand new.",
  },
];

export const FAQS = [
  {
    q: "Why is it important to clean solar panels?",
    a: "Solar panels accumulate dust, pollen, leaves, bird droppings, and debris over time, which reduces efficiency. Professional cleaning improves energy production and extends the system's lifespan.",
  },
  {
    q: "How often should solar panels be cleaned?",
    a: "In Florida, it is recommended to clean solar panels 1 to 2 times per year, depending on dust levels, nearby trees, rain, and buildup.",
  },
  {
    q: "How much energy can dirty panels lose?",
    a: "Dirty solar panels can lose between 10% and 25% efficiency, meaning less energy production for your home.",
  },
  {
    q: "What types of properties do you service?",
    a: "We work with residential homes, commercial properties, and small to large solar systems.",
  },
  {
    q: "How can I tell if my panels need cleaning?",
    a: "Signs include visible dirt or stains, bird droppings, accumulated leaves, and reduced energy production.",
  },
  {
    q: "What happens if my solar panels are very dirty?",
    a: "We perform deep cleaning services to restore appearance and improve energy output.",
  },
  {
    q: "Do you work on high or difficult roofs?",
    a: "Yes. Our team is trained to work on various roof types and solar system configurations.",
  },
  {
    q: "Do you offer visual system inspections?",
    a: "Yes. During service, we can perform a basic visual inspection to detect visible issues.",
  },
  {
    q: "What water do you use for cleaning?",
    a: "We use purified water and professional equipment that leaves no residue or mineral buildup.",
  },
  {
    q: "Can cleaning damage the system?",
    a: "No. When done correctly with proper tools, cleaning is completely safe.",
  },
  {
    q: "Can I clean my solar panels myself?",
    a: "It is not recommended. Walking on roofs or using improper products can damage panels or cause accidents.",
  },
  {
    q: "How long does cleaning take?",
    a: "Most residential cleanings take between 1 to 2 hours depending on system size and roof access.",
  },
  {
    q: "Do you offer same-day service?",
    a: "Depending on availability, we can often provide same-day or next-day service.",
  },
  {
    q: "How do I schedule a service?",
    a: "You can call us, send a WhatsApp message, or use the contact form on this page.",
  },
  {
    q: "Do you provide free estimates?",
    a: "Yes. We offer free, no-obligation quotes.",
  },
  {
    q: "Do you serve commercial properties?",
    a: "Yes. We provide services for both homes and businesses.",
  },
  {
    q: "What areas do you serve?",
    a: "We serve Tampa and surrounding Tampa Bay areas.",
  },
  {
    q: "Do you offer solar panel removal services?",
    a: "Yes. We offer removal for roof replacement, repairs, or maintenance.",
  },
  {
    q: "Do you reinstall panels after roof repairs?",
    a: "Yes. We can reinstall your solar system after roofing work is completed.",
  },
  {
    q: "What makes your company different?",
    a: "We focus on professional service, fast response, competitive pricing, and extensive experience with solar systems.",
  },
];
